import { IconUser, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { Tag } from '../../../Tag'
import { RuleContent, RuleDescription, RuleIcon } from '../../RuleStack'
import { messages } from '../messages'

export function MaxUsagePerClientView(props: { restriction: number }) {
  const { restriction } = props

  return (
    <>
      <RuleIcon>
        <IconUser />
      </RuleIcon>

      <RuleDescription>
        <FormattedMessage
          {...messages.view.maxUsagePerClient}
          values={{
            b: (content) => <Text variant="body">{content}</Text>,
          }}
        />
      </RuleDescription>

      <RuleContent>
        <Tag>
          <FormattedMessage
            {...messages.view.quantity}
            values={{ value: restriction }}
          />
        </Tag>
      </RuleContent>
    </>
  )
}
